import { put, takeLatest, call } from 'redux-saga/effects';
import { serializeKeys } from '@iso/lib/helpers/keyNormalizer';
import request from '@iso/lib/helpers/httpClient';
import * as CONSTANTS from './constants';
import * as ACTIONS from './actions';

function* fetchGoogleLoginUrl({companyId}) {
  try {
    let data = null;
    if(companyId){
      data = yield call(
        request,
        `/company/${companyId}/company_contacts/auth?service_provider=GOOGLE`,
        'GET',
        null
      );
    }else{
      data = yield call(
        request,
        '/user_contacts/auth?service_provider=GOOGLE',
        'GET',
        null
      );
    }
    yield put(ACTIONS.fetchGoogleLoginUrlSuccess(serializeKeys(data)));
  } catch (error) {
    yield put(ACTIONS.fetchGoogleLoginUrlFail(error));
  }
}

function* fetchCompanyDetail({ id }) {
  try {
    const data = yield call(request, `/company/${id}/`, 'GET', null);
    yield put(ACTIONS.fetchCompanyDetailSuccess(serializeKeys(data)));
  } catch (error) {
    yield put(ACTIONS.fetchCompanyDetailFail(error));
  }
}

export default function* contactImportSaga() {
  yield takeLatest(
    CONSTANTS.FETCH_GOOGLE_LOGIN_URL_REQUEST,
    fetchGoogleLoginUrl
  );
  yield takeLatest(CONSTANTS.FETCH_COMPANY_DETAIL_REQUEST, fetchCompanyDetail);
}
